const initialState = {}

export default (state = initialState, action) => {
  switch (action.type) {
    case "levelEvaluation/SET_LEVEL_EVALUATION":
      return {
        ...state,
        [action.levelEvaluationUUID]: {
          ...state[action.levelEvaluationUUID],
          result: action.payload,
        },
      }
    case "levelEvaluation/SET_LOADING":
      return {
        ...state,
        [action.levelEvaluationUUID]: {
          ...state[action.levelEvaluationUUID],
          loading: action.payload,
        },
      }
    case "levelEvaluation/SET_ERROR":
      return {
        ...state,
        [action.levelEvaluationUUID]: {
          ...state[action.levelEvaluationUUID],
          error: action.payload,
        },
      }
    case "LOGOUT":
      return initialState
    default:
      return state
  }
}
